var map = {
	"./banheiro.png": 2475,
	"./cozinha.png": 6199,
	"./escritorio.png": 3989,
	"./fachada.png": 9786,
	"./logo.png": 6949,
	"./quarto.png": 8033,
	"./quarto_old.png": 6163,
	"./sala.png": 5618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;